
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[tenantId]/games/[gameId]/live",
      function () {
        return require("private-next-pages/[tenantId]/games/[gameId]/live/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[tenantId]/games/[gameId]/live"])
      });
    }
  